<template>
    <div class="attribute-edit">
        <!-- Filters Title -->
        <div class="filters-title">
            <h2>Filters</h2>
        </div>

        <!-- Top Section for Age/Gender/Hours -->
        <div class="top-filters-section">
            <div class="top-filter-item">
                <label class="filter-label">Age:</label>
                <select class="top-selection-box" @change="handleSelect('age', $event)">
                    <option v-for="(age, idx) in ageSelection" :key="age.value">{{ age.value }}</option>
                </select>
            </div>
            <div class="top-filter-item">
                <label class="filter-label">Gender:</label>
                <select class="top-selection-box" @change="handleSelect('gender', $event)">
                    <option v-for="(gender, idx) in genderSelection" :key="gender.value">{{ gender.value }}</option>
                </select>
            </div>
            <div class="top-filter-item">
                <label class="filter-label">Hours/week:</label>
                <select class="top-selection-box" @change="handleSelect('hours', $event)">
                    <option v-for="(hours, idx) in hoursSelection" :key="hours.value">{{ hours.value }}</option>
                </select>
            </div>
        </div>

        <!-- Horizontal Filter Grid Panel -->
        <div class="filter-panel">
            <div class="filter-grid-container">
                <div class="filter-card" :class="{ 'active': openDropdowns[field_index] }" v-for="(fieldObject, field_index) in testerFields" :key="fieldObject.field_index">
                    <div class="filter-card-header" @click="toggleDropdown(field_index)">
                        <span class="filter-card-title">{{ fieldObject.displayName }}</span>
                        <span class="dropdown-arrow" :class="{ 'rotated': openDropdowns[field_index] }">▼</span>
                    </div>
                    <div class="filter-dropdown" v-show="openDropdowns[field_index]">
                        <div class="filter-options">
                            <button
                                v-for="(fieldValue, value_index) in returnNotAddedValues(fieldObject.fieldValues)"
                                :key="value_index"
                                :id="value_index"
                                class="filter-option-btn"
                                @click="handleFieldValue(fieldValue.value, fieldObject.fieldName, field_index)">
                                {{ fieldValue.value }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Selected Filters Display Panel -->
        <div class="controls-panel">
            <div class="filtering-testers">
                <!-- Buttons Container -->
                <div class="button-container">
                    <Transition name="bounce">
                    <b-button @click="handleClear" v-if="showClearButton">
                        CLEAR
                    </b-button>
                    </Transition>
                    <input id="attribute-confirm" type="submit" value="CONFIRM" @click.prevent="handleConfirm"/>
                </div>
                
                <!-- Aligned Selected Tags Container with Columns -->
                <div class="selected-tags-columns-container">
                    <div class="selected-tags-column" v-for="(fieldObject, field_index) in testerFields" :key="field_index">
                        <div class="column-header">{{ fieldObject.displayName }}</div>
                        <div class="column-tags">
                            <b-button 
                                v-for="(selectedFieldValue, index) in getSelectedTagsForField(field_index)"
                                :key="index"
                                class="selected-tag"
                                v-bind:variant="selectedFieldValue.variant"
                                @click="handleSelectedFieldValue(selectedFieldValue.fieldValue, selectedFieldValue.field_index)"
                            >
                                {{selectedFieldValue.fieldValue}}
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Loading from '../loading/index.vue'
    import PlayTesterUser from "../../Firestore/PlayTesterUser";
    import UserObject from "../../Firestore/UserObject";

    export default {
        name: "gameInfoEdit",
        components: {
            Loading
        },
        data() {
            return {
                ageSelected: [],
                genderSelected: [],
                hoursSelected: [],
                platformSelected: [],
                behaviorSelected: [],
                genreSelected: [],
                profileSelected: [],
                purchasingBehaviorSelected: [],
                selectedFieldValues: [], // play tester fields that are selected
                openDropdowns: {}, // track which dropdowns are open
                variantsList: ["primary", "success",
                "danger", "warning", "info", "light",
                "dark"], // list of variants to group field values by their field
                showClearButton: true,

                testerFields: [
                    { 
                        fieldName: "platform", 
                        displayName: "Platform",
                        fieldValues: [{value: "Mobile", isAdded: false}, {value: "Game Console", isAdded: false},
                        {value: "PC/Laptop", isAdded: false}, {value: "Handheld", isAdded: false}, {value: "VR", isAdded: false}]
                    },
                    { 
                        fieldName: "behavior", 
                        displayName: "Behavior",
                        fieldValues: [{value: "Competition", isAdded: false}, {value: "Completion", isAdded: false},
                        {value: "Community/Social", isAdded: false}, {value: "Design", isAdded: false}, {value: "Destruction", isAdded: false},
                        {value: "Fantasy", isAdded:false}, {value: "Story", isAdded: false}]
                    },
                    { 
                        fieldName: "genre", 
                        displayName: "Genre",
                        fieldValues: [{value: "Action", isAdded: false}, {value: "Adventure", isAdded: false},
                        {value: "Casual/Puzzle", isAdded: false}, {value: "Multiplayer Online", isAdded: false}, {value: "Role Playing Game", isAdded: false},
                        {value: "Shooter", isAdded: false}, {value: "Simulation", isAdded: false},
                        {value: "Sports", isAdded: false}, {value: "Strategy", isAdded: false}]
                    },
                    { 
                        fieldName: "profile", 
                        displayName: "Profile",
                        fieldValues: [{value: "Gamer in a Past Life", isAdded: false}, {value: "Conventional", isAdded: false},
                        {value: "Popcorn/Recreational", isAdded: false}, {value: "Ultimate Gamer", isAdded: false}, {value: "Time Filler", isAdded: false}]
                    },
                    { 
                        fieldName: "purchasingBehavior", 
                        displayName: "Purchasing Behavior",
                        fieldValues: [{value: "One Time Game Purchases", isAdded: false}, {value: "Additional Game Content", isAdded: false},
                        {value: "Lootboxes", isAdded: false}, {value: "Characters", isAdded: false}, {value: "Subscriptions", isAdded: false},
                        {value: "Cosmetics", isAdded: false}, {value: "Free to Play", isAdded: false}]
                    },
                ], // play tester fields that can be selected in the filter

                userType: window.localStorage.getItem("userType") ? parseInt(window.localStorage.getItem("userType")) : -1,  // 0: Tester, 1: Company, 2: Admin
                isLoading: false,
                // Technically a copy but newData might get used by other stuff.
                testerId: window.localStorage.getItem("userId"),
                newData: {
                    age: [],
                    testerId: window.localStorage.getItem("userId"),
                    gender: [],
                    hours: [],
                    platform: [],
                    behavior: [],
                    genre: [],
                    profile: [],
                    purchasingBehavior: []
                },

                ageSelection: [
                    {
                        value: "<18"
                    },
                    {
                        value: "18 - 34"
                    },
                    {
                        value: "35 - 54"
                    },
                    {
                        value: "55 - 64"
                    },
                    {
                        value: "65+"
                    }
                ],
                genderSelection: [
                    {
                        value: "Male"
                    },
                    {
                        value: "Female"
                    },
                    {
                        value: "Non Binary"
                    },
                    {
                        value: "Prefer not to say"
                    }
                ],
                hoursSelection: [
                    {
                        value: "0-5"
                    },
                    {
                        value: "6-10"
                    },
                    {
                        value: "11-15"
                    },
                    {
                        value: "16-20"
                    },
                    {
                        value: "21-30"
                    },
                    {
                        value: "31+"
                    }
                ],
            }
        },
        mounted() {
            this.loadInitialValues();
            document.addEventListener('click', this.handleClickOutside);
        },
        methods: {
            // Get selected tags for a specific field index
            getSelectedTagsForField(field_index) {
                return this.selectedFieldValues.filter(tag => tag.field_index === field_index);
            },
            
            toggleDropdown(field_index) {
                // Close all other dropdowns first
                const newState = {};
                Object.keys(this.openDropdowns).forEach(key => {
                    newState[key] = false;
                });
                // Toggle the clicked dropdown
                newState[field_index] = !this.openDropdowns[field_index];
                this.openDropdowns = newState;
            },

            // Close dropdowns when clicking outside
            handleClickOutside(event) {
                if (!event.target.closest('.filter-card')) {
                    this.openDropdowns = {};
                }
            },

            beforeDestroy() {
                document.removeEventListener('click', this.handleClickOutside);
            },

            // return field values that are not added to selectedFieldValues
            returnNotAddedValues: function(fieldValues) {
                return fieldValues.filter(value => !value.isAdded)
            },

           loadInitialValues: function () {
            /** Load the initial values of the Playtester's stuff from the database and display them. */
            this.isLoading = true;
            PlayTesterUser.getPlayTesterProfile(this.testerId)
                .then(response => {
                let userData = response.data;

                // Clean out the ID
                delete userData.testerID;

                // Handle age/gender/hours separately
                if (userData.age && userData.age.length) {
                    this.ageSelected = [userData.age[0]];
                }
                if (userData.gender && userData.gender.length) {
                    this.genderSelected = [userData.gender[0]];
                }
                if (userData.hours && userData.hours.length) {
                    this.hoursSelected = [userData.hours[0]];
                }

                delete userData.age;
                delete userData.gender;
                delete userData.hours;

                // Now process all other attributes
                for (const [key, values] of Object.entries(userData)) {
                    const fieldIndex = this.testerFields.findIndex(f => f.fieldName === key);
                    if (fieldIndex !== -1 && Array.isArray(values)) {
                    for (const tag of values) {
                        this.handleFieldValue(tag, key, fieldIndex);
                    }
                    }
                }

                this.isLoading = false;
                })
                .catch(err => {
                if (err.error === PlayTesterUser.PROFILE_DNE) {
                    console.log("Continuing without loading data since the profile DNE. But careful!");
                    this.isLoading = false;
                } else {
                    alert(err);
                    throw err;
                }
                });
            },


            // add the clicked field value to selectedFieldValues
            handleFieldValue: function(fieldValue, fieldObject, field_index) {
                const numberOfVariants = this.variantsList.length
                const variant = this.variantsList[field_index % numberOfVariants]

                const targetValue = this.testerFields[field_index].fieldValues.filter(value => value.value === fieldValue)
                targetValue.forEach(value => value.isAdded = true)

                this.selectedFieldValues.push({fieldValue, variant, field_index})
                if (fieldObject === "platform") {
                    this.platformSelected.push(fieldValue);
                } else if (fieldObject === "behavior") {
                    this.behaviorSelected.push(fieldValue);
                } else if (fieldObject === "genre") {
                    this.genreSelected.push(fieldValue);
                }else if (fieldObject === "profile") {
                    this.profileSelected.push(fieldValue);
                }else if (fieldObject === "purchasingBehavior") {
                    this.purchasingBehaviorSelected.push(fieldValue);
                }
            },

            // remove the selected field value from selectedFieldValues
            handleSelectedFieldValue: function(fieldValue, field_index) {
                const targetValue = this.testerFields[field_index].fieldValues.filter(value => value.value === fieldValue)
                targetValue.forEach(value => value.isAdded = false)

                const fieldName = this.testerFields[field_index].fieldName;
                this.selectedFieldValues = this.selectedFieldValues.filter(value => value.fieldValue !== fieldValue)
                // Remove it from the sub-lists as well, otherwise we'll feed fake data to the back-end.

              if (fieldName === "platform") {
                console.log(`Removing ${fieldValue} from selected ${fieldName}`);
                this.platformSelected = this.platformSelected.filter(value => value !== fieldValue)
              } else if (fieldName === "behavior") {
                console.log(`Removing ${fieldValue} from selected ${fieldName}`);
                this.behaviorSelected = this.behaviorSelected.filter(value => value !== fieldValue);
              } else if (fieldName === "genre") {
                console.log(`Removing ${fieldValue} from selected ${fieldName}`);
                this.genreSelected = this.genreSelected.filter(value => value !== fieldValue);
              } else if (fieldName === "profile") {
                console.log(`Removing ${fieldValue} from selected ${fieldName}`);
                this.profileSelected = this.profileSelected.filter(value => value !== fieldValue)
              } else if (fieldName === "purchasingBehavior") {
                console.log(`Removing ${fieldValue} from selected ${fieldName}`);
                this.purchasingBehaviorSelected = this.purchasingBehaviorSelected.filter(value => value !== fieldValue);
              }
            },

            // remove all selected field values from selectedFieldValues
            handleClear: function() {
              this.showClearButton = false;
                setTimeout(() => {
                this.ageSelected = ["<18"];
                this.genderSelected = ["Male"];
                this.hoursSelected = ["0-5"];
                this.platformSelected = [];
                this.behaviorSelected = [];
                this.genreSelected = [];
                this.profileSelected = [];
                this.purchasingBehaviorSelected = [];
                this.selectedFieldValues.forEach(value => {
                    this.handleSelectedFieldValue(value.fieldValue, value.field_index)
                })
                this.showClearButton = true;
              }, 500);
            },

            handleSelect(box, event) {
                const idx = event.target.selectedIndex;
                if (box === "age") {
                    this.ageSelected = [this.ageSelection[idx].value];
                } else if (box === "gender") {
                    this.genderSelected = [this.genderSelection[idx].value];
                } else if (box === "hours") {
                    this.hoursSelected = [this.hoursSelection[idx].value];
                }
            },

handleConfirm: function () {
    this.$emit('confirmed');
    this.isLoading = true;

    // Make sure arrays are plain before sending to Firestore
    const payload = {
        age: [...this.ageSelected],
        behavior: [...this.behaviorSelected],
        gender: [...this.genderSelected],
        genre: [...this.genreSelected],
        hours: [...this.hoursSelected],
        platform: [...this.platformSelected],
        profile: [...this.profileSelected],
        purchasingBehavior: [...this.purchasingBehaviorSelected],
        testerId: window.localStorage.getItem("userId"),
    };

    PlayTesterUser.createPlayTesterProfile(payload)
        .then(res => {
            this.isLoading = false;

            // Show Achievement popup if there is an achievement
            if (res.achieved) {
                this.$snackbar.showSnackbar("New Achievement: Complete Profile!", "#28a745");
            }

            /** * CHANGE: Redirect to profile instead of dashboard 
             * Make sure 'profile' matches the name defined in your router (index.js)
             */
            this.$router.push({ name: 'userprofile' }); 
        })
        .catch(error => {
            console.log("Error saving playtester profile:", error);
            this.isLoading = false;
        });
},

        }
    }
</script>

<style scoped>

.filters-title {
    text-align: center;
    margin-bottom: 20px;
}

.filters-title h2 {
    color: #FC7727;
    font-weight: bold;
    font-size: 36px;
    margin-bottom: 10px;
    position: relative;
}

.filters-title::after {
    content: '';
    display: block;
    width: 100%;
    height: 3px;
    background-color: #FC7727;
    margin-top: 10px;
}

.top-filters-section {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 60px;
    margin: 20px 0 30px 0;
    padding: 25px;
    background: #f8f9fa;
    border-radius: 8px;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    border-bottom: 1px solid #d0d0d0;
    margin-bottom: 40px;
}

.filter-panel {
    background: white;
    border-radius: 10px;
    padding: 30px;
    margin: 40px auto;
    max-width: 1200px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    border: 1px solid #e8e8e8;
}

.controls-panel {
    background: white;
    border-radius: 10px;
    padding: 30px;
    margin: 40px auto;
    max-width: 1200px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    border: 1px solid #e8e8e8;
}

.top-filter-item {
    display: flex;
    align-items: center;
    gap: 10px;
}

.filter-label {
    font-weight: bold;
    color: #4b4b4d;
    font-size: 16px;
    min-width: 90px;
}

.top-selection-box {
    padding: 10px 15px;
    border: 2px solid #e0e0e0;
    border-radius: 6px;
    background: white;
    font-weight: 500;
    font-size: 14px;
    color: #4b4b4d;
    min-width: 140px;
    transition: all 0.2s ease;
}

.top-selection-box:hover {
    border-color: #FC7727;
    background-color: #fff8f5;
}

.top-selection-box:focus {
    outline: none;
    border-color: #FC7727;
    box-shadow: 0 0 0 3px rgba(252, 119, 39, 0.1);
}

.filter-grid-container {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
    margin: 0;
    max-width: 100%;
}

.filter-card {
    background: white;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    min-height: 60px;
    position: relative;
    transition: all 0.3s ease;
}

.filter-card:hover {
    border-color: #FC7727;
    box-shadow: 0 2px 8px rgba(252, 119, 39, 0.15);
}

.filter-card.active {
    border-color: #FC7727;
    box-shadow: 0 4px 12px rgba(252, 119, 39, 0.2);
}

.filter-card-header {
    padding: 15px 18px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f8f9fa;
    border-radius: 6px;
    min-height: 30px;
}

.filter-card-title {
    font-weight: 600;
    color: #4b4b4d;
    font-size: 15px;
}

.dropdown-arrow {
    transition: transform 0.3s ease;
    color: #FC7727;
    font-weight: bold;
    font-size: 14px;
}

.dropdown-arrow.rotated {
    transform: rotate(180deg);
}

.filter-dropdown {
    position: absolute;
    top: calc(100% - 2px);
    left: -2px;
    right: -2px;
    background: white;
    border: 2px solid #FC7727;
    border-top: none;
    border-radius: 0 0 8px 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    z-index: 1000;
    max-height: 250px;
    overflow-y: auto;
}

.filter-options {
    padding: 10px;
}

.filter-option-btn {
    display: block;
    width: 100%;
    padding: 8px 12px;
    margin-bottom: 5px;
    background: #f8f9fa;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    cursor: pointer;
    text-align: left;
    transition: all 0.2s ease;
    color: #4b4b4d;
    font-size: 14px;
}

.filter-option-btn:hover {
    background: #FC7727;
    color: white;
    border-color: #FC7727;
    transform: translateY(-1px);
}

.filter-option-btn:last-child {
    margin-bottom: 0;
}

/* Bottom Section */
.filtering-testers {
    margin-top: 0;
}

.button-container {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #d0d0d0;
}

#attribute-confirm {
    width: 180px;
    height: 45px;
    background: #FC7727;
    border: none;
    cursor: pointer;
    color: #ffffff;
    border-radius: 6px;
    font-weight: 600;
    font-size: 15px;
    transition: all 0.2s ease;
}

#attribute-confirm:hover {
    background: #FF8C00;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(255, 140, 0, 0.3);
}

.selected-tags-columns-container {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
    margin-top: 20px;
}

.selected-tags-column {
    min-height: 100px;
}

.column-header {
    font-weight: 600;
    color: #4b4b4d;
    font-size: 15px;
    text-align: center;
    padding: 10px;
    background: #f8f9fa;
    border-radius: 6px;
    margin-bottom: 10px;
    border: 2px solid #e0e0e0;
}

.column-tags {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
}

.selected-tag {
    margin: 0 !important;
    font-size: 13px !important;
    padding: 6px 10px !important;
    border-radius: 4px !important;
    width: 90%;
    text-align: center;
}

.bounce-enter-active, .bounce-leave-active {
  transition: transform .3s;
}
.bounce-enter, .bounce-leave-to {
  transform: scale(0.7);
}

@media (max-width: 768px) {
    .top-filters-section {
        flex-direction: column;
        gap: 20px;
    }
    
    .filter-grid-container,
    .selected-tags-columns-container {
        grid-template-columns: 1fr;
        gap: 15px;
    }
    
    .filters-title h2 {
        font-size: 28px;
    }
}

@media (max-width: 1000px) {
    .filter-grid-container,
    .selected-tags-columns-container {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 1200px) and (min-width: 1001px) {
    .filter-grid-container,
    .selected-tags-columns-container {
        grid-template-columns: repeat(4, 1fr);
    }
}

</style>


// WEBPACK FOOTER //
// src/components/user-profile/AttributeEdit.vue